import {
    GET_DAILY_REPORT_DATA,
    GET_DAILY_REPORT_DATA_SUCCESS,
    GET_DAILY_REPORT_DATA_FAILURE,
    GET_ALL_REPORTS_DATA,
    GET_ALL_REPORTS_DATA_SUCCESS,
    GET_ALL_REPORTS_DATA_FAILURE,
    UPDATE_REPORT_NOTES_SUCCESS,
    UPDATE_REPORT_NOTES_FAILURE,
    EXPORT_DOC_SUCCESS,
    EXPORT_DOC_FAILURE, EXPORT_DOC, UPDATE_REPORT_NOTES
} from './constants';

const initialState = {
    loading: true,
    reports: {},
    allReports: {},
    totalCount: undefined,
    addedReportNote: undefined,
    exportedDoc: undefined,
    doc: undefined
};

const dailyReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DAILY_REPORT_DATA: {
            return Object.assign({}, state, {loading: false, addedReportNote: undefined, exportedDoc: undefined, doc: undefined});
        }
        case GET_DAILY_REPORT_DATA_SUCCESS: {
            return Object.assign({}, state, {loading: false, reports: action.data.reports, totalCount: action.data.totalCount, addedReportNote: undefined, exportedDoc: undefined, doc: undefined});
        }
        case GET_DAILY_REPORT_DATA_FAILURE: {
            return Object.assign({}, state, {loading: false, reports: {}, totalCount: undefined, addedReportNote: undefined, exportedDoc: undefined, doc: undefined});
        }
        case GET_ALL_REPORTS_DATA: {
            return Object.assign({}, state, {loading: false, addedReportNote: undefined, exportedDoc: undefined, doc: undefined});
        }
        case GET_ALL_REPORTS_DATA_SUCCESS: {
            return Object.assign({}, state, {loading: false, allReports: action.data.reports, totalCount: action.data.totalCount, addedReportNote: undefined, exportedDoc: undefined, doc: undefined});
        }
        case GET_ALL_REPORTS_DATA_FAILURE: {
            return Object.assign({}, state, {loading: false, allReports: {}, totalCount: undefined, addedReportNote: undefined, exportedDoc: undefined, doc: undefined});
        }
        case UPDATE_REPORT_NOTES: {
            return Object.assign({}, state, {loading: false, addedReportNote: undefined, texportedDoc: undefined, doc: undefined});
        }
        case UPDATE_REPORT_NOTES_SUCCESS: {
            return Object.assign({}, state, {loading: false, addedReportNote: true, exportedDoc: undefined, doc: undefined});
        }
        case UPDATE_REPORT_NOTES_FAILURE: {
            return Object.assign({}, state, {loading: false, addedReportNote: false, exportedDoc: undefined, doc: undefined});
        }
        case EXPORT_DOC: {
            return Object.assign({}, state, {loading: false, addedReportNote: undefined, exportedDoc: undefined, doc: undefined});
        }
        case EXPORT_DOC_SUCCESS: {
            return Object.assign({}, state, {loading: false, addedReportNote: undefined, exportedDoc: true, doc: action.data});
        }
        case EXPORT_DOC_FAILURE: {
            return Object.assign({}, state, {loading: false, addedReportNote: undefined, exportedDoc: false, doc: undefined});
        }
        default: {
            return state;
        }
    }
};

export default dailyReportReducer;



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/DailyReport/reducer.js